import React from "react"
import { CloseButton, Modal, ModalBody } from "reactstrap"
import Lottie from "react-lottie"
import animationData from "../../../assets/lotties/error-alert"

function ErrorAlert({ modal, toggle, content, err }) {
  const defaultOptions = {
    loop: 1,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  }

  return (
    <Modal isOpen={modal} toggle={toggle}>
      <ModalBody style={{ backgroundColor: "#FEF0F1FF" }}>
        <div className="d-flex">
          <div className="me-4">
            <Lottie
              options={defaultOptions}
              height={40}
              width={40}
              eventListeners={[
                {
                  eventName: "loopComplete",
                  callback: () => {
                    // Add a delay before closing the modal
                    setTimeout(() => {
                      toggle();
                    }, 3000); // 3000 milliseconds = 3 seconds
                  },
                },
              ]}
            />
          </div>
          <div className="w-100">
            <div className="d-flex justify-content-between">
              <h4 style={{ color: "#F22128FF" }}>Error</h4>
              <CloseButton onClick={toggle} />
            </div>
            {content} failed!
          </div>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default ErrorAlert
